<template lang="pug">
	div.mb-1
		.input-group
			.input-group-prepend
				.input-group-text
					span.fa.fa-user
			input.form-control(v-model="nom", placeholder="Nombre")
			.input-group-append
				.input-group-text
					span.fa.fa-phone
			input.form-control(v-model="tel", v-mask="'#### ### ## ## ##'")
</template>

<script>
export default {
	props: ['telefono', 'nombre'],
	data () {
		return {
			tel: '',
			nom: ''
		}
	},
	created () {
		this.tel = this.telefono
		this.nom = this.nombre
	},
	watch: {
		tel: function (newVal) {
			this.$emit('update:telefono', this.tel)
		},
		nom: function (newVal) {
			this.$emit('update:nombre', this.nom)
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/escaletas/vue/components/editor/telefono.vue